import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './ModalDialog.module.scss';
import classNames from 'classnames';

export default class ModalDialog extends Component {
    static propTypes = {
        visible: PropTypes.bool,
    };

    render() {
        const {visible, children} = this.props;

        const modalAreaClassName = classNames(styles.modalArea, {
            [styles.modalAreaVisibled]: visible,
        });

        return (
            <div className={modalAreaClassName}>
                <div className={styles.modalOverlay} />
                <div className={styles.modalDialog}>{children}</div>
            </div>
        );
    }
}
